import { AudioSpeed } from '@dataclouder/ngx-core';
import { AudioGenerated, ChatUserSettings, MessageContent, TTSRequest } from '../../../../models/agent.models';
import { removeEmojis } from '../../../../utils/icons/extraction.regex';

export function matchTranscription(originalText: string, transcription: any[]): any[] {
  const result: any[] = [];
  const transcriptionMap = new Map<string, any[]>();

  // Create a map of lowercase words to an array of their corresponding objects in transcription
  for (const obj of transcription) {
    const lowercaseWord = obj.word.trim().toLowerCase();
    if (transcriptionMap.has(lowercaseWord)) {
      transcriptionMap.get(lowercaseWord)!.push(obj);
    } else {
      transcriptionMap.set(lowercaseWord, [obj]);
    }
  }

  // Split the original text into an array of words
  const words = originalText.split(' ');

  let currentTime = 0;

  for (const word of words) {
    const lowercaseWord = word.toLowerCase();
    const matchedObjs = transcriptionMap.get(lowercaseWord);

    if (matchedObjs && matchedObjs.length > 0) {
      const matchedObj = matchedObjs.shift();
      result.push({
        word: word,
        start: Number(matchedObj.start.toFixed(3)),
        end: Number(matchedObj.end.toFixed(3)),
      });
      currentTime = matchedObj.end;
    } else {
      result.push({
        word: word,
        start: Number(currentTime.toFixed(3)),
        end: Number(currentTime.toFixed(3)),
      });
    }
  }
  return result;
}

export function extractAudioAndTranscription(message: MessageContent, audio: AudioGenerated): MessageContent {
  message.audioUrl = audio.blobUrl;
  message.transcription = audio.transcription;

  if (message.transcription) {
    message.transcriptionTimestamps = matchTranscription(message.text || message.content, message.transcription.words);
  }
  return message;
}

export function buildObjectTTSRequest(message: MessageContent, settings: ChatUserSettings = {} as ChatUserSettings): TTSRequest {
  const generateTranscription = settings?.highlightWords ?? false;
  const speedRate = settings?.speedRate || 0;
  const speed = typeof settings?.speed === 'string' ? settings.speed : AudioSpeed.Regular;

  const text = removeEmojis(message.text || message.content);
  const ssml = message.ssml ? removeEmojis(message.ssml) : null;

  return {
    text,
    voice: message.voice || settings.voice,
    generateTranscription,
    speedRate,
    speed,
    ssml: ssml,
  };
}
